import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.MyFinalDecisionBadge', {
    myFinalDecisionApproved: 'Approved by me',
    myFinalDecisionRejected: 'Rejected by me',
});
